import React from 'react';
import classNames from 'classnames';
import { Loader } from 'semantic-ui-react';
import './JsonLink.scss';

interface JsonLinkProps {
  data: object | null | undefined;
  dataTestId?: string;
  isSelected?: boolean;
  onClick: () => void;
  text: string | null | undefined;
}

/**
 * Renders either an n/a label, a clickable link to display
 * a JSON object, or a loader spinner.
 */
export const JsonLink: React.FC<JsonLinkProps> = ({
  data,
  dataTestId,
  isSelected,
  onClick,
  text,
}) => {
  if (data === null) {
    return <div>n/a</div>;
  }
  if (data && text) {
    return (
      <div
        className={classNames('lending-support-link', {
          'lending-support-link-selected': isSelected,
        })}
        data-testid={dataTestId}
        onClick={onClick}
      >
        {text}
      </div>
    );
  }
  return <Loader data-testid="loader" size="small" active={!text} inline />;
};
